import React from "react";
import axios from "services/axiosB2C";
import Axios from "axios";
import { RequestToken } from "../../../../services/b2c";

import { Button, Card, message, Spin, Tooltip, Tag, Modal } from "antd";
import { Link } from "react-router-dom";
import MUIDataTable from "mui-datatables";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import momentTZ from "moment-timezone";
import _ from "lodash";

import { formatNumber } from "../../../Utils/index";
import { errorMessage } from "../../../Utils";

const modalConfirm = Modal.confirm;

let cancelToken;

class CarBookingList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      carBookingList: [],
      page: 1,
      limit: 15,
      count: 0,
      search: "",
      sort: { name: "create", direction: "desc" },
      isLoading: false,
    };
  }

  componentDidMount() {
    this.fetchCarBooking(this.state.page, this.state.limit);
  }

  async fetchCarBooking(page, limit) {
    this.setState({ isLoading: true });

    let { sort, search } = this.state;
    let order = this.orderBy(sort);
    let query = `${order}&page=${page}&limit=${limit}&search=${search || ""}`;

    if (cancelToken) {
      cancelToken.cancel("Operation canceled due to new request");
    }
    cancelToken = Axios.CancelToken.source();
    let token = await RequestToken();

    await axios
      .get(`/carbookings?${query}`, {
        cancelToken: cancelToken.token,
        headers: {
          Authorization: token,
        },
      })
      .then(result => {
        this.setState({
          carBookingList: result.data.carBookings,
          page: result.data.page,
          limit: result.data.limit,
          count: result.data.count,
          isLoading: false,
        });
      })
      .catch(err => {
        if (!Axios.isCancel(err)) {
          errorMessage(err.response || err);
          this.setState({ isLoading: false });
        }
      });
  }

  orderBy(sort) {
    let key = "date";
    let value = "desc";

    //Get Key
    if (sort.name === "Hari/Tgl Dibuat") key = "create";

    //Get Value
    if (sort.direction === "asc") value = "asc";
    else if (sort.direction === "desc") value = "desc";

    return `sort_by=${key}&order_by=${value}`;
  }

  changePage(page, limit) {
    this.setState({ isLoading: true });
    this.fetchCarBooking(page, limit);
  }

  getMuiTheme = () =>
    createMuiTheme({
      typography: {
        useNextVariants: true,
      },
      overrides: {
        MUIDataTableBodyCell: {
          root: {
            "white-space": "nowrap",
            "&:nth-child(1)": {
              width: "8em",
              "min-width": "8em",
              "max-width": "8em",
              "word-break": "break-all",
            },
          },
        },
      },
    });

  async sendToAstra(id) {
    let self = this;
    modalConfirm({
      title: `Car Booking Service`,
      content: "Kirim ke Astra?",
      async onOk() {
        self.setState({ isLoading: true });
        let token = await RequestToken();
        axios
          .put(
            `/carbookings/resend-to-astra/${id}`,
            {},
            {
              headers: {
                Authorization: token,
              },
            }
          )
          .then(res => {
            message.success("Berhasil terkirim ke Astra");
            self.fetchCarBooking();
          })
          .catch(e => {
            if (e.response) {
              if (e.response.data || e.response.message) {
                message.error(
                  e.response.data.message ||
                    e.response.message ||
                    e.response.data
                );
              } else {
                message.error("Gagal terkirim ke Astra");
              }
            } else {
              message.error("Gagal terkirim ke Astra");
            }
            self.setState({ isLoading: false });
          });
      },
      onCancel() {
        message.warning("Batal terkirim ke Astra");
      },
    });
  }

  render() {
    //Columns
    const columns = [
      {
        name: "Action",
        options: {
          sort: false,
        },
      },
      {
        name: "status",
        options: {
          sort: false,
        },
      },
      {
        name: "Email Customer",
        options: {
          sort: false,
        },
      },
      {
        name: "Phone",
        options: {
          sort: false,
        },
      },
      {
        name: "Service Type",
        options: {
          sort: false,
        },
      },
      {
        name: "Car Name",
        options: {
          sort: false,
        },
      },
      {
        name: "Cabang",
        options: {
          sort: false,
        },
      },
      {
        name: "Tanggal Service",
        options: {
          sort: false,
        },
      },
      {
        name: "Jarak Tempuh",
        options: {
          sort: false,
        },
      },
      {
        name: "Hari/Tgl Dibuat",
        options: {
          sort: false,
        },
      },
    ];

    // Data Car Booking Service List
    const carBookingList = this.state.carBookingList.map((item, idx) => {
      return [
        <div>
          <Link to={`/home/car-booking-service/${item.id}`}>
            <Tooltip placement="bottom" title="Detail Customer Car">
              <Button icon="bars" style={{ marginRight: 10 }} />
            </Tooltip>
          </Link>

          <Tooltip placement="bottom" title="Send To Astra">
            <Button
              style={
                item.is_send_to_astra
                  ? {}
                  : {
                      backgroundColor: "#52c41a",
                      color: "white",
                    }
              }
              disabled={item.is_send_to_astra}
              icon="check"
              onClick={() => this.sendToAstra(item.id)}
            />
          </Tooltip>
        </div>,
        item.is_send_to_astra ? (
          <Tag color="green" style={{ minWidth: 90, textAlign: "center" }}>
            <p style={{ marginBottom: 0 }}>Confirmed</p>
            <p style={{ marginBottom: 0 }}>to Astra</p>
          </Tag>
        ) : (
          <Tag color="magenta" style={{ minWidth: 90, textAlign: "center" }}>
            <p style={{ marginBottom: 0 }}>Waiting</p>
            <p style={{ marginBottom: 0 }}>confirmation</p>
          </Tag>
        ),
        item.email,
        item.phone,
        item.service_type,
        item.car_name,
        item.branch,
        momentTZ(item.service_date)
          .tz("Asia/Jakarta")
          .format("dddd, D MMMM YYYY HH:mm"),
        formatNumber(item.mileage),
        momentTZ(item.created_at)
          .tz("Asia/Jakarta")
          .format("dddd, D MMMM YYYY HH:mm"),
      ];
    });

    //Options
    const options = {
      filter: false,
      responsive: "simple",
      fixedHeader: true,
      tableBodyHeight: "460px",
      print: false,
      selectableRows: "none",
      // resizableColumns: true,
      download: false,
      viewColumns: false,
      serverSide: true,
      rowsPerPage: parseInt(this.state.limit),
      count: this.state.count,
      page: this.state.page - 1,
      searchText: this.state.search,
      sortOrder: this.state.sort,
      onTableChange: (action, tableState) => {
        switch (action) {
          case "changePage":
            this.changePage(tableState.page + 1, tableState.rowsPerPage);
            break;
          case "changeRowsPerPage":
            this.changePage(1, tableState.rowsPerPage);
            break;
          case "search":
            this.setState({ search: tableState.searchText }, () =>
              this.changePage(1, tableState.rowsPerPage)
            );
            break;
          case "sort":
            this.setState({ sort: tableState.sortOrder }, () =>
              this.changePage(1, tableState.rowsPerPage)
            );
            break;
          default:
            break;
        }
      },
    };

    return (
      <Card
        title="Car Booking Service List"
        style={{
          marginTop: 35,
          background: "#fff",
          minHeight: 360,
        }}>
        <Spin size="large" spinning={this.state.isLoading} tip="Loading...">
          <MuiThemeProvider theme={this.getMuiTheme()}>
            <MUIDataTable
              title="Car Booking Service"
              data={carBookingList}
              columns={columns}
              options={options}
            />
          </MuiThemeProvider>
        </Spin>
      </Card>
    );
  }
}

export default CarBookingList;



// WEBPACK FOOTER //
// src/components/Dashboard/B2C/CarBooking/CarBooking.js